import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../Components/Spinner/Spinner";
import baseUrl from "../../baseUrl";

const UpdateProduct = () => {
  const token = JSON.parse(localStorage.getItem("admin-token"));
  const { id } = useParams();
  const navigate = useNavigate();

  const [productName, setProductName] = useState("");
  const [brand, setBrand] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [uses, setUses] = useState("");
  const [sideEffects, setSideEffects] = useState("");
  const [dosages, setDosages] = useState("");
  const [onStock, setOnStock] = useState("");
  const [price, setPrice] = useState("");
  const [precaution, setPrecaution] = useState("");

  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/single-product/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setProductName(res.data.product.name);
        setBrand(res.data.product.brand);
        setCategory(res.data.product.category);
        setDescription(res.data.product.description);
        setUses(res.data.product.uses);
        setSideEffects(res.data.product.sideEffects);
        setDosages(res.data.product.dosages);
        setOnStock(res.data.product.onStock);
        setPrice(res.data.product.price);
        setPrecaution(res.data.product.precaution);
      });
  }, [id, token]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (
      productName &&
      brand &&
      category &&
      description &&
      uses &&
      sideEffects &&
      dosages &&
      onStock &&
      price &&
      precaution
    ) {
      axios
        .post(
          `${baseUrl}/admin/update-product/${id}`,
          {
            name: productName,
            brand: brand,
            category: category,
            description: description,
            uses: uses,
            sideEffects: sideEffects,
            dosages: dosages,
            onStock: onStock,
            price: price,
            precaution: precaution,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.success == true) {
            toast.success(res.data.message);
            navigate("/admin/all-products");
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      {productName.length <= 0 && <Spinner />}
      <nav
        className=" w-auto container text-black font-bold mx-5 my-4"
        aria-label="Breadcrumb"
      >
        <h3 className="text-gray-700 text-3xl font-medium">Update Product</h3>
      </nav>
      <div className="container mx-auto">
        <div className="flex justify-center px-6 my-12">
          <div className="w-full xl:w-3/4 lg:w-11/12 flex">
            <div className="w-full lg:w-7/12 bg-white p-5 mx-auto rounded-lg lg:rounded-l-none">
              <h3 className="pt-4 text-2xl text-center">Update Product</h3>
              <form
                className="px-8 pt-6 pb-8 mb-4 bg-white rounded"
                onSubmit={handleUpdate}
              >
                <div className="mb-4 md:flex md:justify-between">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Name
                    </label>
                    <input
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      name="productName"
                      value={productName}
                      onChange={(e) => setProductName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="md:ml-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Category
                    </label>
                    <input
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      name="category"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="mb-4 md:flex md:justify-between">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Description
                    </label>
                    <textarea
                      rows="5"
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      name="description"
                      required
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                    ></textarea>
                  </div>
                  <div className="md:ml-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Price
                    </label>
                    <input
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="number"
                      name="price"
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-4 md:flex md:justify-between">
                  <div className="md:ml-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Brand
                    </label>
                    <input
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      name="brand"
                      value={brand}
                      onChange={(e) => setBrand(e.target.value)}
                      required
                    />
                  </div>

                  <div className="md:ml-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      In Stock
                    </label>
                    <input
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="number"
                      value={onStock}
                      name="stock"
                      min="0"
                      onChange={(e) => setOnStock(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-4 md:flex md:justify-between">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Uses
                    </label>
                    <textarea
                      rows="5"
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      name="uses"
                      onChange={(e) => setUses(e.target.value)}
                      required
                      value={uses}
                    ></textarea>
                  </div>
                  <div className="md:ml-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Side Effects
                    </label>
                    <textarea
                      rows="5"
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      name="sideeffects"
                      onChange={(e) => setSideEffects(e.target.value)}
                      required
                      value={sideEffects}
                    ></textarea>
                  </div>
                </div>
                <div className="mb-4 md:flex md:justify-between">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Dosages
                    </label>
                    <textarea
                      rows="5"
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      name="dosages"
                      onChange={(e) => setDosages(e.target.value)}
                      required
                      value={dosages}
                    ></textarea>
                  </div>
                  <div className="md:ml-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Precaution & Warning
                    </label>
                    <textarea
                      rows="5"
                      className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      name="precaution"
                      onChange={(e) => setPrecaution(e.target.value)}
                      required
                      value={precaution}
                    ></textarea>
                  </div>
                </div>
                <div className="mb-6 text-center">
                  <button
                    className="w-full px-4 py-2 font-bold text-white bg-blue-500 rounded-full hover:bg-blue-700 focus:outline-none focus:shadow-outline"
                    type="submit"
                  >
                    Update Product
                  </button>
                </div>
                <hr className="mb-6 border-t" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateProduct;
